import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormControl } from 'material-ui/Form';
import { MenuItem } from 'material-ui/Menu';
import { withStyles } from 'material-ui/styles';
import AppBar from 'material-ui/AppBar';
import Select from 'material-ui/Select';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import Button from '../Parts/Button';
import ArrowToolTip from "../common/ArrowToolTip";

const styles = theme => ({
  root: {
    width: "100%",
    height: "60px",
    transition: 'transform 0.3s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.3s cubic-bezier(0.77, 0, 0.175, 1)',
  },

  formControl: {
    marginRight: 15,
  },

  menuItem: {
    display: 'inline-flex',
    marginRight: 25,
  },

  deselect: {
    textDecoration: 'underline',
  },

  flex: {
    flex: 1,
  },

  appBar: {
    color: "#181819",
    background: "#FFFFFF",
    padding: '0px 35px',
    boxShadow: '11px 1px 10px 0px rgba(0, 0, 0, 0.12)',
  },

  btn: {
    borderRadius: '2px',
    padding: '10px 18px',
    fontSize: 13,
    color: '#FFFFFF',
    backgroundColor: '#1A65FF',
    '&:hover': {
      backgroundColor: '#1A65FF',
      opacity: .6,
    }
  },

  btnDisabled: {
    borderRadius: '2px',
    padding: '10px 18px',
    fontSize: 13,
    color: '#B1B3B9',
    backgroundColor: '#F4F6F9',
    border: '1px solid #D8DBDF',
  },

  select: {
    fontSize: '15px',
    minWidth: '290px',
    backgroundColor: theme.palette.common.white,
    border: 'none',
    borderBottom: '1px solid #D8DBDF',
    padding: '8px 12px',
  },

  paper: {
    maxHeight: 'unset',
  }
});

class BottomMenu extends React.Component {
  state = {
    value: this.props.showSelectOption ? -1 : 0,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.props.open) {
      this.setState({ value: nextProps.showSelectOption ? -1 : 0 });
    }
  }

  /* Event Listeners */
  handleChange = (event) => {
    this.setState({ value: event.target.value });
  };

  handleClick = () => {
    if (this.props.isDemo) {
      this.props.togglePlanDialog();
    } else {
      this.props.menuItems.find(item => item.value.toString() === this.state.value.toString()).action();
    }
  };

  handleDeselect = () => {
    this.props.deselectAll(false);
  };

  render() {
    const { classes, menuItems, buttonText, open } = this.props;

    let disabled = (this.state.value === -1);
    let disableMessage = null;

    if (this.props.menuItems && this.props.menuItems.find(item => item.value.toString() === this.state.value.toString())) {
      disabled = (disabled || this.props.menuItems.find(item => item.value.toString() === this.state.value.toString()).disabled);
      disableMessage = this.props.menuItems.find(item => item.value.toString() === this.state.value.toString()).disableMessage;
    }

    return (
      <div className={classes.root} style={{ transform: open ? 'translateY(0%)' : 'translateY(100%)', visibility: open ? 'visible' : 'hidden' }}>
        <AppBar position="static" color="default" className={classes.appBar}>
          <Toolbar style={{ padding: 0 }}>
            <Typography
              variant="subheading"
              style={{ fontWeight: 'bold' }}
              className={classNames(classes.menuItem)}
            >
              {this.props.numSelected} 項目選択中
            </Typography>

            {!this.props.isMinLetterOrderCount && (
              <Typography
                variant="body1"
                style={{ marginRight: 15 }}
              >
                {this.props.minLetterOrderCount}件以上から注文可能
              </Typography>
            )}

            <Typography
              onClick={this.handleDeselect}
              variant="body1"
              className={classNames('clickable', classes.deselect)}>
              選択を解除
            </Typography>

            <div className={classes.flex}></div>

            <FormControl className={classes.formControl}>
              <Select
                value={this.state.value}
                id="filter-by"
                onChange={this.handleChange}
                classes={{ select: classes.select }}
                MenuProps={{
                  classes: {
                    paper: classes.paper
                  }
                }}
              >
                {this.props.showSelectOption && <MenuItem value={-1} key={-1}>アクションを選択してください</MenuItem>}
                {menuItems.map(item => {
                  return (
                    <MenuItem value={item.value} key={item.value}>{item.text}</MenuItem>
                  )
                })}
              </Select>
            </FormControl>
            <React.Fragment>
              {(disableMessage) ? (
                <ArrowToolTip
                  text={disableMessage}
                  placement="top"
                >
                  <div>
                    <Button
                      text={buttonText}
                      handleClickButton={() => alert('ご利用いただけません。')}
                      style={{ marginRight: '15px', pointerEvents: (disableMessage) ? 'none' : '' }} // disabled属性だとホバーアウトした場合、ツールチップが消えないので、pointerEventsで代用
                      loading={this.props.menuItems.hasOwnProperty(this.state.value) && this.props.menuItems[this.state.value].loading}
                      disabled={true}
                    />
                  </div>
                </ArrowToolTip>
              ) : (
                <Button
                  text={buttonText}
                  handleClickButton={this.handleClick}
                  style={{ marginRight: '15px' }}
                  loading={this.props.menuItems.hasOwnProperty(this.state.value) && this.props.menuItems[this.state.value].loading}
                  disabled={disabled}
                />
              )}
            </React.Fragment>

          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

BottomMenu.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number,
  deselectAll: PropTypes.func.isRequired,
  menuItems: PropTypes.array.isRequired, // array of { text, value, action}
  buttonText: PropTypes.string,
  open: PropTypes.bool,
  showSelectOption: PropTypes.bool,
  isMinLetterOrderCount: PropTypes.bool,
  minLetterOrderCount: PropTypes.number,
  isDemo: PropTypes.bool,
  togglePlanDialog: PropTypes.func,
};

BottomMenu.defaultProps = {
  buttonText: "確定",
  showSelectOption: true,
  isMinLetterOrderCount: true,
};

export default withStyles(styles)(BottomMenu);



// WEBPACK FOOTER //
// ./src/components/common/BottomMenu.jsx